import { createFileRoute } from "@tanstack/react-router";
import { AccountPanel } from "../../components/Settings/Account/AccountPanel";

export const Route = createFileRoute("/settings/account")({
	component: AccountPanel,
});
